import { createSanitizationProfile, htmlTagGroups, } from 'utils/sanitizeHtml/utils/createSanitizationProfile/createSanitizationProfile';
import { transformTagA } from '../../utils/transformTags';
/**
 * Represents the widget chat channel specific sanitization profile.
 *
 * Note that this should be kept in sync with
 * https://github.com/dixahq/libtext/blob/86c1ea6cab241a54f5e67b98e1a7ca3961315793/src/main/scala/com/dixa/text/HtmlSanitizer.scala#L17
 */
export const widgetChatSanitizationProfile = createSanitizationProfile({
    allowedTags: [
        ...htmlTagGroups.italic,
        ...htmlTagGroups.bold,
        ...htmlTagGroups.list,
        ...htmlTagGroups.heading,
        ...htmlTagGroups.inlineCode,
        ...htmlTagGroups.blockCode,
        'a',
        'img',
        'blockquote',
    ],
    allowedAttributes: {
        a: ['href'],
        img: ['src', 'alt'],
    },
    transformTags: {
        a: transformTagA,
    },
});
